'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var eventNames = {exports: {}};

exports.eventNames = eventNames;
